import IGroup from "interfaces/models/IGroup";
import { GlobalState } from "little-state-machine";

export const updateGroupsFilteredUserApplications = (state: GlobalState, groupsFilteredUserApplications: IGroup[]) => ({
  ...state,
  groupsFilteredUserApplications
});
